// assets/reviewio-loader.js
(function(){
  // IMPORTANT: replace with the installation script URL provided by your Reviews.io Dashboard
  // Example:
  // var REVIEWSIO_SCRIPT = 'https://widget.reviews.io/polaris/build.js';
  var REVIEWSIO_SCRIPT = 'https://widget.reviews.io/polaris/build.js';

  function loadScript(src, cb) {
    if(document.querySelector('script[data-reviewsio]')) { if(cb) cb(); return; }
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    s.setAttribute('data-reviewsio','1');
    s.onload = function(){ cb && cb(); };
    s.onerror = function(){ console.warn('Reviews.io script failed to load'); cb && cb(new Error('failed')); };
    document.head.appendChild(s);
  }

  // initialize using the pending config stored in Liquid
  function initPending(productId) {
    try {
      var pending = window.reviewsioPending && window.reviewsioPending[productId];
      if(!pending) return;
      // If ReviewsWidget constructor exists, use it
      if(window.ReviewsWidget && typeof window.ReviewsWidget === 'function') {
        new window.ReviewsWidget(pending.selector, pending.config);
        return;
      }
      // Otherwise try init method
      if(window.ReviewsWidget && typeof window.ReviewsWidget.init === 'function') {
        window.ReviewsWidget.init(pending.config);
        return;
      }

      // If not available, load script then initialize
      loadScript(REVIEWSIO_SCRIPT, function(err){
        if(err) return;
        if(window.ReviewsWidget && typeof window.ReviewsWidget === 'function') {
          new window.ReviewsWidget(pending.selector, pending.config);
        } else if(window.ReviewsWidget && typeof window.ReviewsWidget.init === 'function') {
          window.ReviewsWidget.init(pending.config);
        } else {
          console.warn('ReviewsWidget not found after script load.');
        }
      });

    } catch(e) { console.warn('initPending error', e); }
  }

  document.addEventListener('DOMContentLoaded', function(){
    if(!window.reviewsioPending) return;

    Object.keys(window.reviewsioPending).forEach(function(productId){
      var pending = window.reviewsioPending[productId];
      if(!pending || !pending.selector) return;
      var rootEl = document.querySelector(pending.selector);
      if(!rootEl) return;

      // IntersectionObserver: when reviews container is near viewport -> preload and init
      if('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(entry.isIntersecting) {
              // load script and init immediately when visible
              loadScript(REVIEWSIO_SCRIPT, function(){
                initPending(productId);
              });
              io.disconnect();
            }
          });
        }, { rootMargin: '600px' });
        io.observe(rootEl);
      } else {
        // fallback: init after short delay if IntersectionObserver not supported
        setTimeout(function(){ loadScript(REVIEWSIO_SCRIPT, function(){ initPending(productId); }); }, 3000);
      }

      // Click trigger for explicit "Read reviews" button
      var openBtn = document.getElementById('open-reviews-' + productId);
      if(openBtn) {
        openBtn.addEventListener('click', function onClick(){
          loadScript(REVIEWSIO_SCRIPT, function(){
            initPending(productId);
            openBtn.setAttribute('aria-expanded','true');
          });
          // run only once
          openBtn.removeEventListener('click', onClick);
        }, { once: true });
      }

      // Hover prefetch to make click feel instant (small delay to avoid accidental loads)
      if(openBtn) {
        openBtn.addEventListener('mouseenter', function(){
          this._t = setTimeout(function(){ loadScript(REVIEWSIO_SCRIPT); }, 350);
        }, { passive: true });
        openBtn.addEventListener('mouseleave', function(){ clearTimeout(openBtn._t); });
      }
    });

    // Idle fallback: prefetch script during idle so later init is faster (uncomment if desired)
    if('requestIdleCallback' in window) {
      requestIdleCallback(function(){
        // loadScript(REVIEWSIO_SCRIPT); // optional: prefetch only
      }, { timeout: 3000 });
    } else {
      // setTimeout(function(){ /* loadScript(REVIEWSIO_SCRIPT); */ }, 8000);
    }
  });
})();
